import { render, staticRenderFns } from "./Ohra.vue?vue&type=template&id=6285db53&scoped=true"
import script from "./Ohra.vue?vue&type=script&lang=js"
export * from "./Ohra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6285db53",
  null
  
)

export default component.exports